module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "EPI"
  }, [_vm._v("Our knowledge isn’t much it’s just a small amount")]), _vm._v(" "), _c('p', {
    staticClass: "EPI"
  }, [_vm._v("But you feel it quick inside you when you’re down for the count")]), _vm._v(" "), _c('p', {
    staticClass: "EPIS"
  }, [_vm._v("—“The Songs We Know Best”")]), _vm._v(" "), _c('p', {
    staticClass: "EPI"
  }, [_vm._v("Of course Eurydice vanished into the shade;")]), _vm._v(" "), _c('p', {
    staticClass: "EPI"
  }, [_vm._v("She would have even if he hadn’t turned around.")]), _vm._v(" "), _c('p', {
    staticClass: "EPIS"
  }, [_vm._v("—“Syringa”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd661e1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 75
// module chunks = 0